export const collection = '/icons/social-media/collection.svg'
export const pdf = '/icons/social-media/pdf-color.svg'
export const blankLogo = `/icons/social-media/blank.png`
export const flowcodeBannerWhite = '/logos/flowcodeTM_horizontal_white.svg'
export const flowcodeBanner = '/logos/flowcodeTM_horizontal_black.svg'
export const fileUpload = '/icons/social-media/file-upload-color.svg'
